import type { ReactNode } from 'react'

interface HomeShellProps {
  children: ReactNode
}

export function HomeShell({ children }: HomeShellProps) {
  return <div className="home-shell">{children}</div>
}
